<script>
    import Icon from './Icon.svelte';

    let overMail = false;
</script>

<section>
    <a
        class="github"
        href="https://github.com/YoDavidO">
        <Icon icon={'github'} />
    </a>
    <a
        class="twitter"
        href="https://twitter.com/yodavido">
        <Icon icon={'twitter'} />
    </a>
    <a
        class="linkedin"
        href="https://linkedin.com/in/yodavido">
        <Icon icon={'linkedin'} />
    </a>
    <a
        class="email"
        href="mailto:david@davidnortiz.com">
        <Icon icon={'email'} />
    </a>
</section>

<style>
    section {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin: 2em auto;
        max-width: 20em;
        width: 100%;
    }
    a {
        color: rgb(75, 75, 75);
        text-decoration: none;
        width: 3em;
    }

    a.github:hover {
        color: #050505;
    }
    a.twitter:hover {
        color: #59A5D8;
    }
    a.linkedin:hover {
        color: #083D77;
    }
    a.email:hover {
        color: #F05D5E;
    }
</style>